export default __webpack_public_path__ + "static/media/plus.da02eaf6.svg";